import { Component } from '@verndale/core';
import Swiper from 'swiper';
import debounce from 'lodash/debounce';
import GlobalFleet from './GlobalFleet';
import FindLounges from '../FindLounges';
import SearchFlights from '../SearchFlights';
import { BREAKPOINT } from '../../constants';

class Services extends Component {
  setupDefaults() {
    this.dom = {
      $window: $(window),
      $slider: this.$el.find('.services__slider'),
      $list: this.$el.find('.services__list'),
      $items: this.$el.find('.services__item'),
      $globalFleet: this.$el.find('.service--global-fleet'),
      $searchFlights: this.$el.find('.service--search-flights'),
      $searchFlightsForm: this.$el.find('.service--search-flights .service__form'),
      $findLounges: this.$el.find('.service--find-lounges'),
      $findLoungesForm: this.$el.find('.service--find-lounges .service__form')
    };

    this.width = document.body.clientWidth;
    this.findFlightUrl = this.dom.$searchFlightsForm.attr('action');
    this.loungeAccessUrl = this.dom.$findLoungesForm.attr('action');

    new GlobalFleet(this.dom.$globalFleet);
    new SearchFlights(this.dom.$searchFlights, {
      onSearch: ::this.handleSearchFlights
    });
    new FindLounges(this.dom.$findLounges, {
      onFind: ::this.handleFindLounges
    });

    //this.initSwiper();
  }

  addListeners() {
    this.dom.$window.on('resize', debounce(::this.handleResize, 300));
  }

  handleResize() {
    if (this.width !== document.body.clientWidth) {
      this.width = document.body.clientWidth;
      this.initSwiper();
    }
  }

  initSwiper() {
    if (document.body.clientWidth >= BREAKPOINT.desktop) {
      if (this.swiper) {
        this.swiper.destroy();
        this.removeStructure();
        this.swiper = null;
      }
      return;
    }
    if (this.swiper) {
      this.swiper.update();
      return;
    }
    this.createStructure();
    this.swiper = new Swiper('.services__slider', {
      slidesPerView: 'auto',
      loop: false
    });
  }

  createStructure() {
    this.dom.$slider.addClass('swiper-container');
    this.dom.$list.addClass('swiper-wrapper');
    this.dom.$items.addClass('swiper-slide');
  }

  removeStructure() {
    this.dom.$slider.removeClass('swiper-container');
    this.dom.$list.removeClass('swiper-wrapper');
    this.dom.$items.removeClass('swiper-slide');
  }

  handleSearchFlights({ departureDateObj, returnDateObj, ...data }) {
    const qsString = $.param(data);
    let url = this.findFlightUrl;
    if (qsString) {
      url = `${url}?${qsString}`;
    }
    location.href = url;
  }

  handleFindLounges(data) {
    const qsString = $.param(data);
    let url = this.loungeAccessUrl;
    if (qsString) {
      url = `${url}?${qsString}`;
    }
    location.href = url;
  }
}

export default Services;
